import {ComponentProps} from "react";
import {css, cx} from "@panda/css";

import {Link} from "@pg-design/link-module";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";

interface IProps extends ComponentProps<typeof Text> {
    linkText?: string;
    linkClassName?: string;
}

export function LeadRodoTerms(props: IProps) {
    const {variant = "info_txt_3", color = "var(--colors-gray-800)", linkText = "zasady przetwarzania danych osobowych.", linkClassName} = props;

    const rodoTermsUrl = rpAppLink.rodoTerms.base();

    return (
        <Text as="span" variant={variant} color={color} {...props}>
            Administratorem danych osobowych świadczonych w związku z realizacja umowy jest Property Group sp. z o.o.{" "}
            <Link href={rodoTermsUrl} target="_blank" textClassName={cx(rodoLink, linkClassName)}>
                {linkText}
            </Link>
        </Text>
    );
}

const rodoLink = css({
    fontSize: "inherit",
    lineHeight: "inherit",
    textDecoration: "underline"
});
import {ComponentProps} from "react";
import {css, cx} from "@panda/css";

import {Link} from "@pg-design/link-module";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";

interface IProps extends ComponentProps<typeof Text> {
    linkText?: string;
    linkClassName?: string;
}

export function LeadRodoTerms(props: IProps) {
    const {variant = "info_txt_3", color = "var(--colors-gray-800)", linkText = "zasady przetwarzania danych osobowych.", linkClassName} = props;

    const rodoTermsUrl = rpAppLink.rodoTerms.base();

    return (
        <Text as="span" variant={variant} color={color} {...props}>
            Administratorem danych osobowych świadczonych w związku z realizacja umowy jest Property Group sp. z o.o.{" "}
            <Link href={rodoTermsUrl} target="_blank" textClassName={cx(rodoLink, linkClassName)}>
                {linkText}
            </Link>
        </Text>
    );
}

const rodoLink = css({
    fontSize: "inherit",
    lineHeight: "inherit",
    textDecoration: "underline"
});
